import React, { useState } from 'react';
import { Row, Col, Button } from 'antd';
const JoinedMembersItemPage = (props) => {
    React.useEffect(() => {


    }, [])
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div>
                <div style={{ width: '100px', height: '100px', backgroundColor: '#000', borderRadius: '50px' }}>

                </div>
                <div style={{ fontSize: '18px', color: '#3D3D3D',textAlign:'center' }}>
                    {props.item}
                </div>
            </div>

        </div>
    )

}

export default JoinedMembersItemPage